import React from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { PALETTE } from '../styles'
import { ProductAnalyticsPlatform } from '../types'

type LimitsNoticeProps = {
  platform: ProductAnalyticsPlatform
}

const LIMIT_KEYS_BY_PLATFORM: Record<ProductAnalyticsPlatform, string[]> = {
  WEB: ['page_path', 'session_duration', 'collection_start'],
  MOBILE: ['mobile_screen_name', 'session_duration'],
}

const LimitsNotice: React.FC<LimitsNoticeProps> = ({ platform }) => {
  const { t } = useTranslation()

  return (
    <Stack
      component="aside"
      direction="row"
      gap={1.5}
      aria-labelledby="product-analytics-limits"
      sx={{
        p: 1.5,
        borderRadius: '16px',
        border: `1px solid ${PALETTE.info.border}`,
        bgcolor: PALETTE.info.background,
        color: PALETTE.info.text,
      }}
    >
      <Box
        component="i"
        className="fa-regular fa-circle-info"
        sx={{ mt: 0.25, fontSize: 12, color: PALETTE.info.icon }}
        aria-hidden="true"
      />
      <Stack gap={0.5}>
        <Typography id="product-analytics-limits" sx={{ fontSize: 12, fontWeight: 500, color: 'inherit' }}>
          {t('stats.product_analytics.limits.title')}
        </Typography>
        <Stack component="ul" gap={0.25} sx={{ m: 0, pl: 2, listStyle: 'disc' }}>
          {LIMIT_KEYS_BY_PLATFORM[platform].map(key => (
            <Typography key={key} component="li" sx={{ fontSize: 12, color: 'inherit' }}>
              {t(`stats.product_analytics.limits.${key}`)}
            </Typography>
          ))}
        </Stack>
      </Stack>
    </Stack>
  )
}

export default LimitsNotice
